import { Map, List } from 'immutable';

import {
  SMS_LIST_REQUEST,
  SMS_LIST_SUCCESS,
  SMS_LIST_FAILURE,
  SMS_READ_REQUEST,
  SMS_READ_SUCCESS,
  SMS_READ_FAILURE,
  SMS_UPDATE_REQUEST,
  SMS_UPDATE_SUCCESS,
  SMS_UPDATE_FAILURE,
  SMS_DELETE_REQUEST,
  SMS_DELETE_SUCCESS,
  SMS_DELETE_FAILURE,
  SMS_FORM_DESTROY,
  SMS_CSV_DOWNLOAD_REQUEST,
  SMS_CSV_DOWNLOAD_SUCCESS,
  SMS_CSV_DOWNLOAD_FAILURE,
} from './actions';
import Logger from '../../../lib/Logger';

export default function smses(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log('debug', `[smses.reducers] smses(%j, %j)`, state, action);

  switch (action.type) {
    case SMS_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case SMS_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ['pages', action.order, action.limit, action.page],
          List(action.result)
        );

    case SMS_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case SMS_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case SMS_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case SMS_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case SMS_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case SMS_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case SMS_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case SMS_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case SMS_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case SMS_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case SMS_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set('form', action.form);

    case SMS_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true,
      });

    case SMS_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case SMS_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `smses.reducers loaded.`);
